import Image from 'next/image'
import Link from 'next/link'
import React, { useState, useRef, useEffect } from 'react'
import { FaArrowRight, FaChevronRight } from 'react-icons/fa'
import { s3Static } from 'utils/constants'

export const TrainerByFitnessType = () => {
    const [showArrow, setShowArrow] = useState(true);
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        const handleScroll = () => {
            const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
            const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 10;
            setShowArrow(!isAtEnd);
        };

        scrollContainer.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => scrollContainer.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToNext = () => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        const cardWidth = scrollContainer.querySelector('section[data-card]')?.offsetWidth || 0;
        const gap = 24; // gap-6 = 1.5rem = 24px
        scrollContainer.scrollBy({
            left: cardWidth + gap,
            behavior: 'smooth'
        });
    };

    // Data list for fitness goals
    const fitnessGoals = [
    {
      title: "Personal Trainer for Weight Loss",
      desc: "Our certified personal trainers specialize in weight loss programs tailored for Singapore's lifestyle combines effective cardio routines, strength training, and customized nutrition plans to help you achieve sustainable fat loss with scientifically-backed methods.",
      href: "/sg/personal-trainer/weight-loss-trainer",
      buttonText: "Weight Loss Trainers"
    },
    {
      title: "Personal Trainer for Muscle Building",
      desc: "Our trainers specialize in hypertrophy training, progressive overload techniques, and optimal recovery strategies designed for Singapore's urban environment, helping you maximize muscle gains and achieve your desired physique.",
      href: "/sg/personal-trainer/body-building-trainer",
      buttonText: "Muscle Growth Trainers"
    },
    {
      title: "Functional Fitness & Mobility Trainer",
      desc: "With functional fitness trainers enhance balance, flexibility, core strength, and real-world movement patterns through dynamic exercises that prevent injuries and improve daily performance.",
      href: "/sg/personal-trainer/personal-trainer-for-functional-fitness",
      buttonText: "Functional Fitness Trainers"
    },
    {
      title: "Trainer for IPPT",
      desc: "StringsSG trainers specialize in IPPT preparation for Singapore's National Service requirements for local fitness standards and provide targeted training programs to improve your 2.4km run times, push-up and sit-up performance, and pull-up strength.",
      href: "/sg/blogs/health-fitness/ippt-personal-trainer-singapore",
      buttonText: "IPPT Trainers"
    }
  ];

  return (
    <section className="max-w-6xl mx-auto my-10 relative">
        <div className='max-w-3xl mx-auto pt-2 text-sm leading-7 space-y-5'>
            <div className='relative w-full h-60 md:h-80'>
                <Image
                    src={s3Static + "personal-trainer/trainer-fardeen-training-elderly.png"}
                    fill
                    style={{objectFit: 'cover', objectPosition: 'top'}}
                    placeholder='blur'
                    blurDataURL={s3Static + "placeholder.png"}
                    alt='Personal Trainer Fitness Goals Singapore - Weight Loss, Muscle Growth, Functional Fitness, IPPT | StringsSG'
                    sizes="(max-width: 768px) 50vw, 100vw"
                />
            </div>
        </div>
        <div className="relative mt-6">
          {/* Scroll Indicator - Only visible on mobile when not at end */}
          {showArrow && (
              <div 
                  className="absolute right-2 top-1/2 -translate-y-1/2 md:hidden z-10 cursor-pointer"
                  onClick={scrollToNext}
              >
                  <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg animate-pulse">
                      <FaChevronRight className="text-2xl text-orange-500" />
                  </div>
              </div>
          )}

          <div
            ref={scrollContainerRef}
            className="flex md:grid md:grid-cols-2 gap-2 overflow-x-auto md:overflow-x-visible snap-x snap-mandatory md:snap-none scroll-smooth pb-4 scrollbar-hide"
            role="list"
            aria-label="Trainer types by fitness goal"
          >
            {fitnessGoals.map(({ title, href, desc, buttonText }) => (
              <section
                key={title}
                data-card
                role="listitem"
                className="border rounded-3xl overflow-hidden shadow-md hover:shadow-xl transition bg-white shrink-0 w-[80vw] sm:w-[70vw] md:w-auto snap-center"
                aria-labelledby={`${title.toLowerCase().replace(/\s+/g, "-")}-heading`}
              >
              <div className="p-5 text-gray-700 text-base leading-relaxed flex flex-col justify-between h-full">
                <div>
                  <div className="flex flex-col items-center text-center space-y-5 mb-4">
                    <h3 id={`${title.toLowerCase().replace(/\s+/g, "-")}-heading`} className="text-lg md:text-xl font-semibold">
                      {title}
                    </h3>
                  </div>
                  <div className='text-sm md:text-base leading-6' dangerouslySetInnerHTML={{ __html: desc }} />
                </div>
                <div className="text-center pt-4 pb-2">
                  <Link
                    href={href}
                    prefetch={false}
                    aria-label={`Explore ${title}`}
                    className="inline-flex items-center px-6 py-3 rounded-2xl bg-orange-500 text-white text-sm md:text-base font-semibold hover:bg-orange-600 transition"
                  >
                    {buttonText} <FaArrowRight className="ml-2" />
                  </Link>
                </div>
              </div>
            </section>
            ))}
          </div>
        </div>
      </section>
  )
}
